import { useRef } from 'react'
import useStyles from './Content.styled'

export const useContent = props => {
	const classes = useStyles(props)
	const sortHandlerParentRef = useRef()

	return [
		{
			...props,

			withImage: !!props.image,
			classes,
			sortHandlerParentRef,
		},
	]
}
